export * from './area.component';